import type { NodeTypes } from '@mv/core/model/heim/richText';
import { Html } from '@mv/ui-kit/primitives';
import type { ReactNode } from 'react';
import { replacePlaceholders } from '../replacePlaceholders';
import type { RichTextContext } from '../RichText';
import { anchorHref } from './anchorHref';

export function LinkNode({
	node,
	children,
	nodeKey,
	context,
}: {
	node: NodeTypes;
	children: ReactNode;
	nodeKey: number;
	context: RichTextContext;
}) {
	const fields = node.fields as { url?: string; linkType?: string; doc?: { value?: { slug?: string } } } | undefined;
	const topLevelUrl = (node as NodeTypes & { url?: unknown }).url;
	const url = typeof fields?.url === 'string' ? fields.url : typeof topLevelUrl === 'string' ? topLevelUrl : undefined;
	const resolution = context.resolveLink({
		node,
		href: typeof url === 'string' ? replacePlaceholders(url, context.replacements) : undefined,
		linkType: fields?.linkType,
		slug: fields?.doc?.value?.slug,
	});

	if (context.screenReaderEnabled) {
		return (
			<Html.Span key={nodeKey} className="text-link underline">
				{children}
			</Html.Span>
		);
	}

	return (
		<Html.A
			key={nodeKey}
			href={anchorHref(resolution)}
			onPress={resolution.onPress}
			accessibilityLabel={resolution.accessibilityLabel}
			hrefAttrs={resolution.target || resolution.rel ? { target: resolution.target, rel: resolution.rel } : undefined}
			className="text-link underline"
		>
			{children}
		</Html.A>
	);
}
